import moment from 'moment';
import {saveAs} from 'file-saver';
export const isEmpty = (val) => {
  return (val === undefined || val === null || val.length <= 0) ? true : false;
}

export const isObjectEmpty = (obj) => {
  return Object.keys(obj).length === 0;
}

export const isNull = (val, res) => {
  return (val === undefined || val === null || val.length <= 0) ? res : val;
}

export const getMenuName = (controllerName, menu) => {
  let stop = false;
  let name = "";
  const currentLanguage = localStorage.getItem('currentLanguage') || 'vn';
  menu.forEach(item => {
    if (stop) return;
    if (item.path && item.path.contains(controllerName)) { name = currentLanguage ==='vn' ? item.name.toUpperCase() : item.nameUS.toUpperCase() ; stop = true; }
    else { item.children.forEach(child => { if (stop) return; if (child.path.includes(controllerName)) { name =  currentLanguage ==='vn' ? child.name.toUpperCase(): child.nameUS.toUpperCase(); stop = true; } }) }
  });
  return name;
}

export const formatDateTimeClient = (date) => {
  const datetime = moment(date);
  if(datetime.isValid())
  {
    return datetime.format('DD/MM/yyyy hh:mm:ss A');
  }
  return '';
}

export const formatDateClient = (date) => {
  const datetime = moment(date);
  if(datetime.isValid())
  {
    return datetime.format('DD/MM/yyyy');
  }
  return '';
}

export const formatDateServer = (date) => {
  const datetime = moment(date);
  if(datetime.isValid())
  {
    return datetime.format('yyyy-MM-DD');
  }
  return '';
}

export const findObjInArr = (options, value) => {
  return options && !isEmpty(value)
      ? options.find((option) => option?.value?.toString() === value?.toString())
      : '';
};

const ChuSo = [ " không "," một "," hai "," ba "," bốn "," năm "," sáu "," bảy "," tám "," chín " ];
const Tien = [ "", " nghìn", " triệu", " tỷ", " nghìn tỷ", " triệu tỷ" ];
function docSoCo3ChuSo(num)
{
    const tram = parseInt(num / 100);
    const chuc = parseInt((num % 100) / 10);
    const donvi = num % 10;
    let KetQua = "";
    if(tram === 0 && chuc === 0 && donvi === 0) return "";
    if(tram !== 0)
    {
      KetQua += ChuSo[tram] + " trăm ";
      if ((chuc === 0) && (donvi !== 0)) KetQua += " linh ";
    }
    if ((chuc !== 0) && (chuc !== 1))
    {
      KetQua += ChuSo[chuc] + " mươi";
      if ((chuc === 0) && (donvi !== 0)) KetQua = KetQua + " linh ";
    }
    if (chuc === 1) KetQua += " mười ";
    switch (donvi)
    {
      case 1:
        if ((chuc !== 0) && (chuc !== 1)) KetQua += " mốt ";
        else KetQua += ChuSo[donvi];
        break;
      case 5:
        if (chuc === 0) KetQua += ChuSo[donvi];
        else KetQua += " lăm ";
        break;
      default:
        if (donvi !== 0) KetQua += ChuSo[donvi];
        break;
    }
    return KetQua;
}

//2. Hàm đọc số thành chữ (Sử dụng hàm đọc số có ba chữ số)
export const docTienThanhChu = (num) =>
{
  let lan=0;
  let i=0;
  let so=0;
  let KetQua="";
  let tmp="";
  let ViTri = [];
  if(num < 0) return "Số tiền âm !";
  if(num === 0) return "Không đồng !";
  if(num > 0) so = num;
  else so = -num;
  if (num > 8999999999999999) return "Số quá lớn!";
  ViTri[5] = Math.floor(so / 1000000000000000);
  if(isNaN(ViTri[5])) ViTri[5] = "0";
  so = so - parseFloat(ViTri[5].toString()) * 1000000000000000;
  ViTri[4] = Math.floor(so / 1000000000000);
  if(isNaN(ViTri[4])) ViTri[4] = "0";
  so = so - parseFloat(ViTri[4].toString()) * 1000000000000;
  ViTri[3] = Math.floor(so / 1000000000);
  if(isNaN(ViTri[3])) ViTri[3] = "0";
  so = so - parseFloat(ViTri[3].toString()) * 1000000000;
  ViTri[2] = parseInt(so / 1000000);
  if(isNaN(ViTri[2])) ViTri[2] = "0";
  ViTri[1] = parseInt((so % 1000000) / 1000);
  if(isNaN(ViTri[1])) ViTri[1] = "0";
  ViTri[0] = parseInt(so % 1000);
  if(isNaN(ViTri[0])) ViTri[0] = "0";
  if (ViTri[5] > 0) lan = 5;
  else if (ViTri[4] > 0) lan = 4;
  else if (ViTri[3] > 0) lan = 3;
  else if (ViTri[2] > 0) lan = 2;
  else if (ViTri[1] > 0) lan = 1;
  else lan = 0;
  for (i = lan; i >= 0; i--)
  {
    tmp = docSoCo3ChuSo(ViTri[i]);
    KetQua += tmp;
    if (ViTri[i] > 0) KetQua += Tien[i];
    if ((i > 0) && (tmp.length > 0)) KetQua += ',';
  }
  if (KetQua.substring(KetQua.length - 1) === ',') KetQua = KetQua.substring(0, KetQua.length - 1);
  KetQua = KetQua.substring(1,2).toUpperCase()+ KetQua.substring(2);
  return KetQua;
}

export const formatCurencyVI = (num) => {
  const formatter = new Intl.NumberFormat("vi-VN");
  const res = formatter.format(num);
  return res !== 'NaN' ? res : '';
}
// export const formatDateTime = (date) => {
//   if (!Number.isNaN(new Date(date).getTime()))
//   {
//     const datetime = new Date(date);
//     const offsetMs = datetime.getTimezoneOffset() * 60 * 1000;
//     const dateLocal = new Date(datetime.getTime() - offsetMs);
//     const dateFormated = dateLocal.toISOString().slice(0, 19).replace(/-/g, "/").replace("T", " ");
//     const dtArr = dateFormated.split(' ');
//     const timeArr = dtArr[1].split(':');
//     const h = timeArr[0] % 12 || 12;
//     const ampm = (timeArr[0] < 12 || timeArr[0] === 24) ? "SA" : "CH";
//     const timeString = `${h}:${timeArr[1]}:${timeArr[2]} ${ampm}`;
//     return `${dtArr[0]} ${timeString}`;
//   }
//   return '';
// }
export const dataURLtoFile =(dataurl, filename) =>{

  var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

  while(n--){
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, {type:mime});
}


export  const checkIfIdExists = (items,idToCheck) => {
  if(items)
    return items.some((item) => item.id === idToCheck);
  return false;
};

export const DownloadFile = (localFilePath, filename) => {
  //const localFilePath = '/path/to/your/local/file.xlsx';
  //const filePath =  'user_image\\OutPutFiles\\DanhSachYeuCauDaChot_DMS_TEAM.xlsx';//  localFilePath;//'/path-to-your-local-file/filename.xlsx';

  fetch(localFilePath)
      .then(response => response.blob())
      .then(blob => {
        saveAs(blob, filename);
      })
      .catch(error => console.error('Error:', error));



 /* axios.get(`file://${localFilePath}`, {
    responseType: 'blob',
  })
      .then(response => {
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        saveAs(blob);
      })
      .catch(error => console.error('Error:', error));*/
}